import { useState } from 'react';

const faqs = [
  {
    question: "Combien coûte un électricien à Genève ?",
    answer: "Le tarif horaire d'un électricien à Genève varie entre CHF 90 et CHF 150 selon la complexité des travaux. HB SERVICES propose des devis gratuits et transparents sous 24h. Pour une installation complète ou une rénovation électrique, nous établissons un devis forfaitaire sans surprise."
  },
  {
    question: "Qu'est-ce que la norme NIBT/OIBT et pourquoi est-ce important ?",
    answer: "La NIBT (Norme d'Installation à Basse Tension) et l'OIBT (Ordonnance sur les Installations à Basse Tension) sont les normes suisses obligatoires pour toutes les installations électriques. Travailler avec un électricien certifié NIBT/OIBT garantit la sécurité de votre installation, sa conformité légale et la validité de votre assurance. HB SERVICES remet un rapport de certification officiel après chaque chantier."
  },
  {
    question: "Intervenez-vous en urgence pour une panne électrique à Genève ?",
    answer: "Oui, HB SERVICES propose un service de dépannage électrique d'urgence 24h/24 et 7j/7 dans tout le canton de Genève. Que ce soit une panne de courant, un disjoncteur qui saute, un court-circuit ou une urgence électrique, nos électriciens interviennent rapidement à Meyrin, Carouge, Lancy, Vernier, Onex et dans tout Genève."
  },
  {
    question: "Installez-vous des bornes de recharge pour voitures électriques à Genève ?",
    answer: "Oui, HB SERVICES installe des bornes de recharge pour véhicules électriques (Wallbox) à domicile et en entreprise à Genève. Nous gérons l'ensemble du projet : étude de faisabilité, installation de la borne, raccordement au tableau électrique et mise en service. Nos bornes supportent jusqu'à 22 kW en triphasé."
  },
  {
    question: "Pouvez-vous rénover l'installation électrique d'un appartement à Genève ?",
    answer: "Absolument. HB SERVICES réalise la rénovation complète d'installations électriques dans les appartements, villas et locaux commerciaux à Genève. Cela inclut le remplacement du tableau électrique, la mise aux normes NIBT, le passage de nouveaux câbles, l'installation de prises et interrupteurs design (Feller, ABB), et la certification finale."
  },
  {
    question: "Proposez-vous des solutions de domotique et maison connectée à Genève ?",
    answer: "Oui, HB SERVICES installe des systèmes domotiques complets à Genève : éclairage intelligent, gestion des stores, thermostat connecté, sécurité intégrée et contrôle à distance via smartphone. Nous travaillons avec les systèmes KNX, Philips Hue et les solutions connectées les plus fiables du marché."
  },
  {
    question: "Dans quelles communes de Genève intervenez-vous ?",
    answer: "HB SERVICES intervient dans tout le canton de Genève : Meyrin, Carouge, Lancy, Vernier, Onex, Thônex, Chêne-Bougeries, Bernex, Plan-les-Ouates, Satigny, Aire-la-Ville, Avully, Avusy, Bardonnex, Bellevue, Choulex, Collex-Bossy, Collonge-Bellerive, Cologny, Confignon, Corsier, Dardagny, Genthod, Grand-Saconnex, Gy, Hermance, Jussy, Laconnex, Meinier, Perly-Certoux, Pregny-Chambésy, Presinge, Puplinge, Russin, Soral, Troinex, Vandœuvres et Veyrier."
  },
  {
    question: "Quelle est la durée d'une installation électrique complète ?",
    answer: "La durée dépend de l'ampleur des travaux. Pour un appartement standard (3-4 pièces), une rénovation électrique complète prend généralement 3 à 5 jours. Pour une nouvelle construction, comptez 1 à 2 semaines. HB SERVICES établit un planning précis avant le début des travaux et s'engage à respecter les délais convenus."
  }
];

export default function ElectriciteFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq-electricite" className="py-24 bg-gray-950">
      <div className="mx-auto max-w-4xl px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/25 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-question-answer-line text-amber-400 text-sm"></i>
            <span className="text-xs font-bold tracking-widest uppercase text-amber-400">Questions fréquentes</span>
          </div>
          <h2 className="text-3xl font-bold text-white sm:text-4xl mb-4">
            Tout savoir sur nos services<br />
            <span className="text-amber-400">d'électricité à Genève</span>
          </h2>
          <p className="text-gray-400 text-sm max-w-xl mx-auto leading-relaxed">
            Les questions les plus posées par nos clients à Genève. Vous ne trouvez pas votre réponse ? Contactez-nous directement.
          </p>
        </div>

        {/* FAQ accordéon */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`rounded-xl border transition-all duration-200 overflow-hidden ${
                openIndex === index
                  ? 'border-amber-500/40 bg-amber-500/5'
                  : 'border-white/8 bg-white/3 hover:border-white/15'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
              >
                <div className="flex items-start gap-3">
                  <div className={`w-6 h-6 flex items-center justify-center rounded-full shrink-0 mt-0.5 text-xs font-bold transition-colors ${
                    openIndex === index ? 'bg-amber-500 text-white' : 'bg-white/10 text-gray-400'
                  }`}>
                    {index + 1}
                  </div>
                  <span className={`text-sm font-semibold leading-snug transition-colors ${
                    openIndex === index ? 'text-amber-400' : 'text-white'
                  }`}>
                    {faq.question}
                  </span>
                </div>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-lg shrink-0 transition-colors ${
                  openIndex === index ? 'text-amber-400' : 'text-gray-500'
                }`}></i>
              </button>

              {openIndex === index && (
                <div className="px-6 pb-5 pl-[3.75rem]">
                  <p className="text-gray-300 text-sm leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA bas */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-6 bg-white/3 border border-white/8 rounded-2xl px-8 py-6">
          <div>
            <p className="text-white font-semibold text-sm mb-1">Vous avez une autre question ?</p>
            <p className="text-gray-400 text-xs">Notre équipe répond sous 24h, du lundi au vendredi.</p>
          </div>
          <a
            href="#contact"
            className="shrink-0 inline-flex items-center gap-2 rounded-lg bg-amber-500 px-6 py-3 text-sm font-semibold text-white hover:bg-amber-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-send-line"></i>
            Nous contacter
          </a>
        </div>
      </div>
    </section>
  );
}
